import { IDirectoryContent } from './IClustersFilesystem';
import { IValue } from './IPickers';

export enum ESignatureType {
    Standard = 'Standard',
    Advanced = 'Advanced',
    Qualified = 'Qualified'
}

export enum EVerificationType {
    Sms = 0,
    Phone = 1,
    AccessCode = 2
}

export enum ESignatureLevelType {
    Standard = 0,
    Advanced = 1
}

export interface IVerificationMethod {
    verificationType: EVerificationType;
    value: string;
}

export interface ISendForSignature {
    files: {
        fileId: string,
        fileName: string
    }[];
    path: string;
    recipients: {
        name: string;
        email: string;
        order: number;
        phoneNumber?: string;
        signatureType?: ESignatureType;
        signatureLevelType?: ESignatureLevelType;
        verificationMethods?: IVerificationMethod[];
        signatureAnchor?: string;
        initialsAnchor?: string;
        dateAnchor?: string;
    }[];
    emailSubject: string;
    emailMessage: string;
    envelopeName?: string;
}

export interface IFormData {
    recipients: IRecipient[];
    subject: string;
    message: string;
    selectedFiles: IDirectoryContent[];
    step?: number;
    isOrderingOn?: boolean;
    isAnchorsOn?: boolean;
}

export interface IRecipient {
    person: IValue;
    order: number;
    signatureType?: ESignatureType;
    phoneCountryCode?: string;
    phoneNumber?: string;
    uid?: string;
    signatureAnchor?: string;
    initialsAnchor?: string;
    dateAnchor?: string;
}

export interface ISignatureResponse {
    clusterId: string;
    dataType: string;
    emailMessage: string;
    emailSubject: string;
    envelopeId: string;
    envelopeName: string;
    files: { fileId: string, fileName: string }[];
    id: string;
    path: string;
    recipients: {
        comment: string;
        email: string;
        id: string;
        isRegistred: boolean;
        name: string;
        order: number;
        status: ESignatureStatusEnum;
        statusChangedDateTime: string;
        userId: string;
    }[];
    sender: {
        id?: string;
        firstName: string;
        lastName: string;
        picture?: string;
        emailContact?: string;
    }
    senderId: string;
    sentDate: string;
    status: ESignatureStatusEnum;
    statusChangedDateTime: string;
    version: string;
}

export enum ESignatureStatusEnum {
    Sent = 'sent',
    Delivered = 'delivered',
    Completed = 'completed',
    Declined = 'declined',
    Created = 'created',
    InProgress = 'in progress',
    Autoresponded = 'autoresponded',
    Voided = 'voided'
}

/** Normalize status from API (e.g. DocuSign may return "InProgress" or "Autoresponded") to ESignatureStatusEnum. */
export function normalizeSignatureStatus(value: string | undefined): ESignatureStatusEnum | undefined {
    if (value == undefined || value === '') return undefined;
    const lower = value.toLowerCase();
    const mapping: Record<string, ESignatureStatusEnum> = {
        'sent': ESignatureStatusEnum.Sent,
        'delivered': ESignatureStatusEnum.Delivered,
        'completed': ESignatureStatusEnum.Completed,
        'declined': ESignatureStatusEnum.Declined,
        'created': ESignatureStatusEnum.Created,
        'in progress': ESignatureStatusEnum.InProgress,
        'inprogress': ESignatureStatusEnum.InProgress,
        'autoresponded': ESignatureStatusEnum.Autoresponded,
        'delivery failure': ESignatureStatusEnum.Autoresponded,
        'deliveryfailure': ESignatureStatusEnum.Autoresponded,
        'voided': ESignatureStatusEnum.Voided
    };
    return mapping[lower] ?? (Object.values(ESignatureStatusEnum).includes(value as ESignatureStatusEnum) ? (value as ESignatureStatusEnum) : undefined);
}
